<template>
  <div>
    <AdButton
      v-if="!item.absent"
      :icon="item.type === 'group' ? 'mdi-checkbox-multiple-marked' : 'mdi-checkbox-marked'"
      text="-"
      :disabled="!editMode"
      @click="unselectItem()"
    />

    <AdSpeedDial v-else :disabled="!editMode" :open-on-hover="false" dropdown>
      <template v-slot:activator="{ on, attrs }">
        <AdButton
          v-bind="attrs" v-on="on"
          :icon="item.type === 'group' ? 'mdi-checkbox-multiple-blank-outline' : 'mdi-checkbox-blank-outline'"
          :disabled="!editMode"
          text="+"
          no-margin-right
        />
      </template>

      <!-- present a list of default buttons for card/conf -->
      <template v-if="item.absent && item.type === 'item'">
        <AdSpeedOption
          text="0..1 R"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'item',
              itemMin: '0',
              itemMax: '1',
              itemConf: 'R',
            })"
        />
        <AdSpeedOption
          text="0..1 C"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'item',
              itemMin: '0',
              itemMax: '1',
              itemConf: 'C',
            })"
        />
        <AdSpeedOption
          text="0..1 O"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'item',
              itemMin: '0',
              itemMax: '1',
              itemConf: 'O',
            })"
        />
        <AdSpeedOption
          text="1..1 R"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'item',
              itemMin: '1',
              itemMax: '1',
              itemConf: 'R',
            })"
        />
        <AdSpeedOption
          text="1..1 M"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'item',
              itemMin: '1',
              itemMax: '1',
              itemConf: 'M',
            })"
        />
        <AdSpeedOption
          text="1..1 C"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'item',
              itemMin: '1',
              itemMax: '1',
              itemConf: 'C',
            })"
        />
        <AdSpeedOption
          text="0..* R"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'item',
              itemMin: '0',
              itemMax: '*',
              itemConf: 'R',
            })"
        />
        <AdSpeedOption
          text="1..* R"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'item',
              itemMin: '1',
              itemMax: '*',
              itemConf: 'R',
            })"
        />
        <AdSpeedOption
          text="1..* M"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'item',
              itemMin: '1',
              itemMax: '*',
              itemConf: 'M',
            })"
        />
        <AdSpeedOption
          text="1..* C"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'item',
              itemMin: '1',
              itemMax: '*',
              itemConf: 'C',
            })"
        />
        <AdSpeedOption
          text="NP"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'item',
              itemMin: '0',
              itemMax: '0',
              itemConf: 'NP',
            })"
        />

      </template>

      <template v-if="item.absent && item.type === 'group'">
        <AdSpeedOption
          :text="`${$t('all')} 0`"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'group',
              itemMin: '0',
              itemMax: '1',
              itemConf: 'O',
            })"
        />
        <AdSpeedOption
          :text="$t('all-zero-one')"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'group',
              itemMin: '0',
              itemMax: '1',
              itemConf: 'R',
            })"
        />
        <AdSpeedOption
          :text="$t('all-one-one')"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'group',
              itemMin: '1',
              itemMax: '1',
              itemConf: 'R',
            })"
        />
        <AdSpeedOption
          :text="$t('groups-one-one-items-zero-one')"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'group',
              itemMin: '1',
              itemMax: '1',
              itemConf: 'R',
              childMin: '0',
              childMax: '1',
              childConf: 'R',
            })"
        />
        <AdSpeedOption
          :text="$t('groups-zero-one-items-one-one')"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'group',
              itemMin: '0',
              itemMax: '1',
              itemConf: 'R',
              childMin: '1',
              childMax: '1',
              childConf: 'R',
            })"
        />

        <AdSpeedOption
          :text="$t('group-only-one-one')"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'item',
              itemMin: '1',
              itemMax: '1',
              itemConf: 'R',
            })"
        />
        <AdSpeedOption
          :text="$t('group-only-zero-one')"
          :list="false"
          list-item
          @click="setCardConf({
              type: 'item',
              itemMin: '0',
              itemMax: '1',
              itemConf: 'R',
            })"
        />
      </template>
    </AdSpeedDial>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    /**
     * Set card and conference.
     * @param data
     */
    setCardConf (data) {
      // Emit set card conf event.
      this.$emit('setCardConf', { item: this.item, data })
    },

    /**
     * Unselect item.
     */
    unselectItem () {
      // Emit unselect item event.
      this.$emit('unselectItem', { item: this.item })
    }
  }
}
</script>
